import React from "react";
import { Box, Flex, Link, Text, useColorMode, Image, VStack, HStack, useColorModeValue } from "@chakra-ui/react";
import { FaLinkedin, FaMapMarkerAlt } from "react-icons/fa";

const Footer = () => {
  const { colorMode } = useColorMode();

  return (
    <Box 
      as="footer" 
      py={6} 
      bg={colorMode === "dark" ? "gray.800" : "gray.200"} 
      color={colorMode === "dark" ? "white" : "gray.600"}
    >
      <Flex 
        direction={{ base: "column", md: "row" }} 
        justify="space-between" 
        align="center" 
        maxWidth="container.xl" 
        mx="auto" 
        px={4}
        position="relative"
      >
        <VStack align={{ base: "center", md: "flex-start" }} mb={{ base: 4, md: 0 }} width="100%">
          <Box 
            width="100%" 
            display="flex" 
            justifyContent={{ base: "center", md: "flex-start" }}
            mb={{ base: 4, md: 0 }}
          >
            <Image
              src={useColorModeValue(require("../assets/images/satoal-logo-black.png"), require("../assets/images/satoal-logo-white.png"))}
              alt="Satoal Logo"
              h={{ base: "50px", sm: "50px", md: "60px", lg: "80px" }}
              maxW={{ base: "120px", sm: "150px", md: "180px", lg: "240px" }}
              objectFit="contain"
            />
          </Box>
          <Text fontWeight="bold" fontSize="md" textAlign={{ base: "center", md: "left" }}>
            SATOAL® Renewable Energies
          </Text>
        </VStack>

        <VStack align={{ base: "center", md: "flex-end" }} spacing={3} width="100%">
          <HStack spacing={2} flexWrap="wrap" justifyContent="center">
            <FaMapMarkerAlt size={20} />
            <Text fontWeight="semibold" fontSize="md" textAlign="center">
              Coronil 11, El cuervo(Sevilla) 41749
            </Text>
          </HStack>
          <Link href="https://www.linkedin.com/company/satoal/" isExternal>
            <FaLinkedin size={24} />
          </Link>
        </VStack>
      </Flex>

      <Text textAlign="center" mt={4} fontSize="sm">
        © 2024 SATOAL® Renewable Energies. All rights reserved.
      </Text>
    </Box>
  );
};

export default Footer;